import { createSlice } from '@reduxjs/toolkit'
import { getPaletteItems, searchPaletteItems } from './asyncPalette'

const initialState = {
  isLoading: true,
  isError: false,
  data: [],
  meta: {},
  page: 1,
  pageSize: 50,
}

export const PALETTE_SLICE = createSlice({
  name: 'palette',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaletteItems.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getPaletteItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.meta = action.payload?.meta || {};
        state.page = action.meta?.arg?.page || 1;
        state.pageSize = action.meta?.arg?.pageSize || state.pageSize;
      })
      .addCase(getPaletteItems.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(searchPaletteItems.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(searchPaletteItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.meta = action.payload?.meta || {};
        state.page = action.meta?.arg?.page || 1;
        state.pageSize = action.meta?.arg?.pageSize || state.pageSize;
      })
      .addCase(searchPaletteItems.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
  },
})

export default PALETTE_SLICE.reducer


